/**
 * 
 */
(function navMenuDirectiveDefinition() {

    'use strict';

    angular.module('NavMenu')
        .directive('navMenu', [
            'config', 'auth',
            function navMenuDirective(config, auth) {
                return {
                    restrict: 'E',
                    templateUrl: config.resourceUrl('/components/ui/layout/nav-menu/nav-menu.html'),
                    transclude: true,
                    scope: {
                        rightMargin: '=',
                        logoutErrorText: '@',
                        loginText: '@',
                        userMenuText: '@',
                        exitText: '@',
                        organizationName: '@',
                        urlIcon: '@',
                        useRegister: '@',
                        disableExternalLogin: '@',
                        showLogin: '&',
                        hideLoginButton: '&',
                        onLogin: '&',
                        doLogout: '&',
                        userNick: '=',
                        userName: '=',
                        linkMode: '='
                    },
                    controller: [
                        '$scope', 'navMenu', '$state', 'errorsExtend', 'loginService',
                        function navMenuDirectiveController($scope, navMenu, $state, errors, loginService) {
                            $scope.useAlwaysNewUI = false;
                            $scope.ouDirectiveOptions = {};

                            $scope.loginResult = function (result) {
                                return $scope.onLogin({ result: result });
                            };

                            $scope.logout = function (result) {
                                return $scope.doLogout({});
                            };

                            $scope.appName = function navMenuDirectiveAppName() {
                                if ($scope.organizationName) {
                                    return $scope.organizationName;
                                }
                                return config.appName();
                            };

                            $scope.menu = {
                                go: function (item) {
                                    if (item.state) {
                                        if (item.keyview) {
                                            $state.go(item.state, { key: item.keyview });
                                        } else {
                                            $state.go(item.state);
                                        }
                                    }
                                    else if (item.fn)
                                        eval('$scope.' + item.fn)();
                                }
                            };

                            $scope.createCORSRequest = function () {
                                auth.createTokenChangeApp().then(function (result) {
                                    window.location = config.custom('edrUrl') + "/#/?t=" + result.token;
                                },
                                    function (error) {
                                        errors.showError(error);
                                    });

                            };

                            $scope.goToNewUI = function (userId) {
                                auth.createTokenChangeApp().then(function (result) {
                                        if (userId) {
                                            loginService.setUser(userId).then(function() {
                                                window.location =
                                                    config.custom('arandanoUrl') + "/#/login/" + result.token;
                                            })
                                        } else {
                                            window.location = config.custom('arandanoUrl') + "/#/login/" + result.token;
                                        }
                                    },
                                    function (error) {
                                        errors.showError(error);
                                    });

                            };

                            $scope.changeOu = function (userId) {
                                var item = {
                                    condition: function () {
                                        return (auth.isLogged());
                                    },
                                    state: 'inicio-changeuser',
                                    keyview: userId
                                };
                                $scope.menu.go(item);
                            };

                            $scope.selecteOu = function (selected) {
                                var item = {
                                    condition: function () {
                                        return (auth.isLogged());
                                    },
                                    text: selected.organizationalUnit.name,
                                    state: 'inicio-changeuser',
                                    keyview: selected.userId
                                };
                                $scope.menu.go(item);
                                $scope.ouDirectiveOptions.clearInput();
                            };

                            var menuItemsChanged = function () {
                                $scope.menu.items = navMenu.getItems();
                                $scope.menu.userItems = navMenu.getUserMenuItems();
                            };

                            $scope.ignoreOnce = function () {
                                $scope.linkMode = null;
                            };

                            $scope.ignoreAll = function () {
                                $scope.linkMode = 3;
                            };

                            $scope.tryArandanos = function () {
                                if ($scope.useAlwaysNewUI) {
                                    errors.showConfirm('UserRedirectAlways').then(function (result) {
                                        if (result) {
                                            $scope.linkMode = 5;
                                            $scope.goToNewUI();
                                        }
                                    });
                                } else {
                                    $scope.linkMode = 2;
                                    $scope.goToNewUI();
                                }
                            };

                            menuItemsChanged();

                            navMenu.whenItemsChange(menuItemsChanged);
                        }
                    ]
                };
            }
        ]);
})();